import { AiFillHtml5 } from "react-icons/ai";
import { DiCss3 } from "react-icons/di";
import { BsBootstrapFill } from "react-icons/bs";
import { SiTailwindcss, SiRedux } from "react-icons/si";
import { TbBrandJavascript, TbBrandNextjs } from "react-icons/tb";
import { FaReact, FaNodeJs } from "react-icons/fa";
import { SiTypescript } from "react-icons/si";
import { SiMongodb } from "react-icons/si";

/* project */
// import TictactoeGame from "../assets/projects/tic-tac-toe.png";
// import githubFinder from "../assets/projects/github-finder.png";
import kicks from "../assets/projects/kicks-mac.png";
import coursenexus from "../assets/projects/coursenexus-mac.png";
import snapify from "../assets/projects/snapify-mac.png";
import codeEditor from "../assets/projects/simple-code-editor-mac.png";
import traceX from "../assets/projects/traceX-mac.png";

/* social icons */
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

/* skills  */
export const skills = {
  frontend: [
    {
      id: "HTML5",
      label: "HTML5",
      icon: <AiFillHtml5 size={25} />,
      width: 90,
    },
    {
      id: "CSS3",
      label: "CSS3",
      icon: <DiCss3 size={25} />,
      width: 90,
    },
    {
      id: "Javascript",
      label: "Javascript",
      icon: <TbBrandJavascript size={25} />,
      width: 90,
    },
    {
      id: "React Js",
      label: "React Js",
      icon: <FaReact size={25} />,
      width: 90,
    },
    {
      id: "Typescript",
      label: "Typescript",
      icon: <SiTypescript size={20} />,
      width: 90,
    },
  ],
  backend: [
    {
      id: "Express Js",
      label: "Express Js",
      icon: <TbBrandJavascript size={25} />,
      width: 50,
    },
    {
      id: "Node Js",
      label: "Node Js",
      icon: <FaNodeJs size={25} />,
      width: 50,
    },
    {
      id: "Mongoose",
      label: "Mongoose",
      icon: <SiMongodb size={25} />,
      width: 50,
    },
  ],
  frameworks: [
    {
      id: "Bootstrap",
      label: "Bootstrap",
      icon: <BsBootstrapFill size={24} />,
      width: 90,
    },
    {
      id: "Tailwind CSS",
      label: "Tailwind CSS",
      icon: <SiTailwindcss size={25} />,
      width: 90,
    },
    {
      id: "Next Js",
      label: "Next Js",
      icon: <TbBrandNextjs size={25} />,
      width: 85,
    },
    {
      id: "React Native",
      label: "React Native",
      icon: <FaReact size={25} />,
      width: 70,
    },
  ],
  "state management": [
    {
      id: "React Redux",
      label: "React Redux",
      icon: <SiRedux size={25} />,
      width: 75,
    },
    {
      id: "Redux Toolkit",
      label: "Redux Toolkit",
      icon: <SiRedux size={25} />,
      width: 75,
    },
  ],
};

/*  project  */
export const projects = [
  {
    id: 1,
    src: traceX,
    name: "TraceX Inventory Management System",
    desc: "I built TraceX, which helps manage products, suppliers, customers, and orders efficiently. It handles stock transactions, product supply, top-selling and low-quantity tracking, and allows manual adjustments for accurate inventory control.",
    skillsIcon: [FaReact, SiTypescript, FaNodeJs, SiTailwindcss],
    skills: ["React Js", "Typescript", "Node Js", "Tailwind Css"],
    demo: "https://coursenexus.netlify.app",
    code: "https://github.com/Firdosh01/TraceX-frontend",
  },
  {
    id: 2,
    src: coursenexus,
    name: "Coursenexus-Ed-tech platform",
    desc: "Coursenexus: Ed-tech platform using MERN stack (MongoDB, ExpressJS, ReactJS, NodeJS). Users create, consume, and rate educational content.",
    skillsIcon: [FaReact, SiTypescript, FaNodeJs, SiTailwindcss],
    skills: ["React Js", "Typescript", "Node Js", "Tailwind Css"],
    demo: "https://coursenexus.netlify.app",
    code: "https://github.com/Firdosh01/Coursenexus",
  },
  {
    id: 3,
    src: kicks,
    name: "Kicks-Shoes E-commerce",
    desc: "Kicks Shoes is a responsive e-commerce platform built with the MERN stack and TypeScript. It features product management, cart functionality, and seamless payment integration with Razorpay for seamless payment processing.",
    skillsIcon: [FaReact, SiTypescript, FaNodeJs, SiTailwindcss],
    skills: ["React Js", "Typescript", "Node Js", "Tailwind Css"],
    demo: "https://kicks-three.vercel.app",
    code: "https://github.com/Firdosh01/Kicks-frontend",
  },
  {
    id: 4,
    src: snapify,
    name: "Snapify Image search",
    desc: "Created a user-friendly image search app in React.js, connected to Unsplash API for quick searches. Made browsing smoother with 20 images displayed per page.",
    skillsIcon: [FaReact],
    skills: ["React Js"],
    demo: "https://snapify-firdosh.vercel.app",
    code: "https://github.com/Firdosh01/Snapify",
  },
  {
    id: 5,
    src: codeEditor,
    name: "DevPlayground",
    desc: "I built a simple code editor using React.js, where users can select a programming language and theme, compile, and execute code. It supports 10+ languages and offers 5+ beautiful themes.",
    skillsIcon: [FaReact, SiTypescript],
    skills: ["React Js", "Typescript"],
    demo: "https://dev-playground-rho.vercel.app",
    code: "https://github.com/Firdosh01/DevPlayground",
  },

  // {
  //   id: 5,
  //   src: TictactoeGame,
  //   name: "Tic-tac toe game",
  //   desc: "Creating a Tic Tac Toe game in JavaScript involves structuring the game board, implementing player turns, checking for a win, and handling user interactions",
  //   skillsIcon: [TbBrandJavascript],
  //   demo: "https://tic-tac-toe-gamedrago.netlify.app",
  //   code: "https://github.com/Firdosh01/Tic-Tac-Toe-Game",
  // },
  // {
  //   id: 6,
  //   src: githubFinder,
  //   name: "Github profile finder",
  //   desc: "Created a user-friendly interface using HTML, CSS, and JavaScript, users to search by GitHub usernames, and app utilizes  GitHub API to fetch and relevant user data display it",
  //   skillsIcon: [TbBrandJavascript],
  //   demo: "https://github-finder-7df9e5.netlify.app",
  //   code: "https://github.com/Firdosh01/Github-finder",
  // },
];

/* social links  */
export const socialLinksData = [
  {
    id: 1,
    child: (
      <>
        LinkedIn <FaLinkedin size={30} />
      </>
    ),
    href: "https://www.linkedin.com/in/firdosh01/",
    style: "rounded-tr-md",
  },
  {
    id: 2,
    child: (
      <>
        Github <FaGithub size={30} />
      </>
    ),
    href: "https://github.com/Firdosh01",
  },
  {
    id: 3,
    child: (
      <>
        Mail <HiOutlineMail size={30} />
      </>
    ),
    href: "mailto: mdfirdosha37@gmail.com",
  },
  {
    id: 4,
    child: (
      <>
        Resume <BsFillPersonLinesFill size={30} />
      </>
    ),
    href: "/Md_Firdosh_Resume.pdf",
    style: "rounded-br-md",
    download: true,
  },
];

export const experienceData = [
  {
    id: 1,
    dates: "Apr 2023 - May 2023",
    title: "Web Developer Intern",
    company: "Groww with Code",
    location: "Remote",
    description: [
      "Assigned real-world web development projects with defined timelines.",
      "Completed and submitted tasks within the given time period for review.",
      "Received feedback after project evaluation and implemented suggested improvements.",
      "Awarded Internship Completion Certificate upon successful review of all assigned work.",
    ],
    skills: ["HTML5", "CSS", "JavaScript", "Tailwind CSS", "React.js"],
  },
  {
    id: 2,
    dates: "Feb 2024 - Present",
    title: "Jr. Software Developer",
    company: "Teckat Services Private Limited",
    location: "On-site",
    description: [
      "Collaborating with the design team to create beautiful, responsive, and cross-browser-compatible web pages.",
      "Building scalable and high-performance web applications using ReactJs, NextJs, and React Native to deliver seamless user experiences across platforms.",
      "Developing reusable components to speed up development, enhance performance, and maintain a consistent user interface throughout the application.",
      "Integrating RESTful APIs with the frontend for real-time data handling, ensuring fast, reliable, and efficient communication between client and server.",
      "Working closely with backend developers to understand API requirements and resolve integration issues efficiently.",
    ],
    skills: [
      "React.js",
      "Next.js",
      "Tailwind Css",
      "Scss",
      "React Native",
      "Ionic",
      "Typescript",
    ],
  },
];

/* navigation  */
export const navigation = [
  {
    id: 1,
    link: "home",
  },
  {
    id: 2,
    link: "about",
  },
  {
    id: 3,
    link: "skills",
  },
  {
    id: 4,
    link: "projects",
  },
  {
    id: 5,
    link: "contact",
  },
];
